// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"528":"141ae753","861":"40b059ea","968":"59b6a90c"}[chunkId] + ".js";
};